import React, { useEffect, useState } from 'react'
import Modal from './Modal'
import Button from '../ui/buttons/Button'
import Input from '../ui/inputs/Input'
import Select from '../ui/selects/Select'
import Textarea from '../ui/inputs/Textarea'
import { X, UserPen } from 'lucide-react'
import { fetchWithCsrf } from '../../utils/fetchWithCsrf'
import { snakecaseKeys } from '../../utils/snakecaseKeys'
import CurrencyInput from '../ui/inputs/CurrencyInput'
import PhoneInput from '../ui/inputs/PhoneInput'
import { camelizeKeys } from '../../utils/camelizeKeys'
import { useToast } from '../ui/toast/ToastContext'

const EditProspectModal = ({ clientId, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    professionId: '',
    previsionMonthlySavings: '',
    leadOrigin: '',
    leadDescription: ''
  })

  const [professionOptions, setProfessionOptions] = useState([])
  const [leadOriginOptions, setLeadOriginOptions] = useState([])
  const { addToast } = useToast()

  useEffect(() => {
    fetch(`/app/planner/prospects/${clientId}`)
      .then(res => res.json())
      .then(data => {
        const camelData = camelizeKeys(data)
        setForm({
          name: camelData.name || '',
          email: camelData.email || '',
          phone: camelData.phone || '',
          professionId: camelData.professionId || '',
          previsionMonthlySavings: camelData.previsionMonthlySavings || '',
          leadOrigin: camelData.leadOrigin || '',
          leadDescription: camelData.leadDescription || ''
        })
      })
      .catch(err => {
        console.error('Erro ao carregar cliente', err)
        addToast({ type: 'error', message: 'Erro ao carregar dados do cliente.' })
      })
  }, [clientId])

  useEffect(() => {
    fetch('/app/shared/form_options')
      .then(res => res.json())
      .then(data => {
        const camelData = camelizeKeys(data)
        const professions = camelData.professions.map(p => ({ label: p.label, value: p.value }))
        const origins = camelData.leadOrigins.map(o => ({ label: o.label, value: o.value }))
        setProfessionOptions(professions)
        setLeadOriginOptions(origins)
      })
      .catch(err => {
        console.error('Erro ao carregar opções do formulário', err)
        addToast({ type: 'error', message: 'Erro ao carregar opções do formulário.' })
      })
  }, [])

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const payload = snakecaseKeys({ prospect: form })

    fetchWithCsrf(`/app/planner/prospects/${clientId}`, {
      method: 'PUT',
      body: JSON.stringify(payload)
    })
      .then(async (res) => {
        if (!res.ok) {
          const json = await res.json()
          throw new Error(json.errors?.join(', ') || 'Erro ao atualizar cliente.')
        }

        addToast({ type: 'success', message: 'Cliente atualizado com sucesso!' })
        onSuccess()
      })
      .catch(err => {
        console.error('Erro ao atualizar cliente:', err)
        addToast({ type: 'error', message: err.message })
      })
  }

  return (
    <Modal onClose={onClose}>
      <div className="p-10">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3 text-blueDarker font-jost text-2xl font-semibold">
            <UserPen size={24} className="text-tealMedium" strokeWidth={1.25} />
            Editar dados do cliente
          </div>
          <button onClick={onClose}>
            <X size={24} className="text-tealBase hover:opacity-80" strokeWidth={1.25} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 font-jost text-sm">
          <div className="md:col-span-2">
            <Input name="name" label="Nome Completo" required value={form.name} onChange={handleChange} />
          </div>
          <Input name="email" label="E-mail" required value={form.email} onChange={handleChange} />
          <PhoneInput name="phone" label="Telefone" required value={form.phone} onChange={handleChange} />
          <Select name="professionId" label="Profissão" value={form.professionId} onChange={handleChange} options={professionOptions} />
          <CurrencyInput name="previsionMonthlySavings" label="Previsão de poupança mensal" value={form.previsionMonthlySavings} onChange={handleChange} />
          <div className="md:col-span-2">
            <Select name="leadOrigin" label="Origem do Lead" value={form.leadOrigin} onChange={handleChange} options={leadOriginOptions} />
          </div>
          <div className="md:col-span-2">
            <Textarea name="leadDescription" label="Observações" value={form.leadDescription} onChange={handleChange} />
          </div>
          <div className="md:col-span-2 flex justify-end mt-1">
            <Button type="submit">SALVAR ALTERAÇÕES</Button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default EditProspectModal
